module.exports = __webpack_public_path__ + "img/manrecht.c1740755.svg";